import { useEffect } from 'react';

const useToggleFavicon = () => {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const updateFavicon = () => {
      const theme = mediaQuery.matches ? 'dark' : 'light';
      setFavicon(theme);
    };

    updateFavicon(); // Set on initial load
    mediaQuery.addEventListener('change', updateFavicon);

    return () => mediaQuery.removeEventListener('change', updateFavicon);
  }, []);

  const setFavicon = (theme: 'light' | 'dark') => {
    let favicon =
      (document.querySelector("link[rel='icon']") as HTMLLinkElement) || null;

    if (!favicon) {
      favicon = document.createElement('link') as HTMLLinkElement;
      favicon.rel = 'icon';
      favicon.type = 'image/x-icon';
      document.head.appendChild(favicon);
    }

    favicon.href = theme === 'dark' ? '/logo.png' : '/logo.png';
  };
};

export default useToggleFavicon;
